import { ActivityItem } from '@cube3/cubicle/src/core/molecules/Activity/ActivityItem';
import React from 'react';
import { useWorkspaceActivityFeed } from '../hooks/useWorkspaceActivityFeed';

export const WorkspaceActivityItem = (props) => {
  const { activity, onClose } = props;

  const { imageSection, topRowSection, bottomRowSection } =
    useWorkspaceActivityFeed(activity, onClose);

  return (
    <ActivityItem
      imageSection={imageSection}
      topRowSection={topRowSection}
      bottomRowSection={bottomRowSection}
    />
  );
};
